import { VNode } from "@dhx/ts-common/dom";
import { Id } from "@dhx/ts-common/types";
import { ItemType, IBaseItem, IBaseItemConfig, IBoxSize, ICoords, IMeasuredItem } from "@dhx/ts-diagram";
import { meta } from "../helpers/baseMetaInfo";

export class BaseItem implements IBaseItem {
	public config;
	public id: Id;

	protected editorNode: VNode;
	protected editableProperty = { key: null, editableId: null };

	constructor(config, params?) {
		this.config = this.setDefaults(config, params.defaults);
		this.id = this.config.id = config.id;
	}
	public isFixed(): boolean {
		return this.config.fixed;
	}
	public isEditable(): boolean {
		return this.config.editable || false;
	}
	public getBaseType(): ItemType {
		return "base";
	}
	public isLocate(box: IMeasuredItem): boolean {
		const { x, y, height, width, dx = 0, dy = 0 } = this.config;

		const XColl = x + width + dx >= box.x && x + dx <= box.x + box.width;
		const YColl = y + height + dy >= box.y && y + dy <= box.y + box.height;

		return XColl && YColl;
	}
	public getBox(): IBoxSize {
		const { x = 0, y = 0, dx = 0, dy = 0, width, height } = this.config;
		const left = x + dx;
		const right = left + width;
		const top = y + dy;
		const bottom = top + height;

		return { left, right, top, bottom };
	}
	public canResize(): boolean {
		return true;
	}
	public render(): VNode {
		return ``;
	}
	public getEditorNode(): VNode {
		return this.editorNode;
	}
	public setEditorNode(editor: VNode, key?: string, editableId?: string): void {
		this.editorNode = editor;
		if (key) {
			this.editableProperty.key = key;
		}
		if (editableId) {
			this.editableProperty.editableId = editableId;
		}
	}
	public destructor() {
		this.config = this.id = null;
	}
	public getMetaInfo(): { [key: string]: string }[] {
		return [meta.text];
	}
	protected getCss(): string {
		const {
			$selected,
			$blockSelected,
			$target,
			assistant = false,
			partner = false,
			catchItem = true,
		} = this.config;

		let css = this.config.css || "";
		if ($selected) css += " dhx_selected ";
		if ($blockSelected) css += " dhx_blockselected ";
		if ($target) {
			if (assistant || partner || !catchItem) {
				css += " dhx_action__target dhx_action__target--doesnt_take";
			} else {
				css += " dhx_action__target dhx_action__target--take";
			}
		}

		return css;
	}
	protected setDefaults(config: IBaseItemConfig, defaults?: IBaseItemConfig): IBaseItemConfig {
		return config;
	}
	protected getCoords(config: IBaseItemConfig): ICoords {
		const { dx, dy, $group, $gx, $gy } = config;
		let { x, y } = config;

		if (dx) x = x + dx;
		if (dy) y = y + dy;

		if ($group) {
			return {
				x: $gx,
				y: $gy,
			};
		} else {
			delete config.$gx;
			delete config.$gy;
		}
		return { x, y };
	}
}
